import { render } from "./Nav.vue?vue&type=template&id=23f913ef&scoped=true"
import script from "./Nav.vue?vue&type=script&lang=js"
export * from "./Nav.vue?vue&type=script&lang=js"

import "./Nav.vue?vue&type=style&index=0&id=23f913ef&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-23f913ef"]])

export default __exports__